import { PeriodFormats } from '../enums/date'

export const DATE_CONSTANTS = {
  TIME_IN_MILLISECONDS: {
    SECOND: 1000,
    MINUTE: 60 * 1000,
    HOUR: 60 * 60 * 1000,
    DAY: 24 * 60 * 60 * 1000,
    WEEK: 7 * 24 * 60 * 60 * 1000,
    MONTH: 30 * 24 * 60 * 60 * 1000,
  },
  TIME_IN_SECONDS: {
    MINUTE: 60,
    HOUR: 60 * 60,
    HALF_DAY: 60 * 60 * 12,
    DAY: 24 * 60 * 60,
    WEEK: 7 * 24 * 60 * 60,
  },
  TIME_IN_MINUTES: {
    HOUR: 60,
    DAY: 24 * 60,
    WEEK: 7 * 24 * 60,
    MONTH: 60 * 24 * 30,
  },
  TIME_IN_HOURS: {
    DAY: 24,
  },
  PERIOD_OPTIONS: [
    PeriodFormats.TODAY,
    PeriodFormats.LAST_7_DAYS,
    PeriodFormats.LAST_MONTH,
    PeriodFormats.LAST_3_MONTHS,
    PeriodFormats.LAST_6_MONTHS,
    PeriodFormats.LAST_12_MONTHS,
    PeriodFormats.THIS_YEAR,
    PeriodFormats.LAST_YEAR,
  ],
  PERIOD_ENERGY_OPTIONS: [
    PeriodFormats.TODAY,
    PeriodFormats.THIS_WEEK,
    PeriodFormats.THIS_MONTH,
    PeriodFormats.PAST_MONTH,
    PeriodFormats.THIS_3_MONTHS,
    PeriodFormats.THIS_6_MONTHS,
    PeriodFormats.THIS_12_MONTHS,
    PeriodFormats.THIS_YEAR,
    PeriodFormats.LAST_YEAR,
  ],
  FUTURE_PERIOD_OPTIONS: [
    PeriodFormats.TODAY,
    PeriodFormats.TOMORROW,
    PeriodFormats.NEXT_7_DAYS,
    PeriodFormats.NEXT_30_DAYS,
    PeriodFormats.NEXT_3_MONTHS,
    PeriodFormats.NEXT_6_MONTHS,
    PeriodFormats.NEXT_YEAR,
  ],
  DUE_DATE_OPTIONS: [
    PeriodFormats.TODAY,
    PeriodFormats.TOMORROW,
    PeriodFormats.NEXT_7_DAYS,
    PeriodFormats.NEXT_30_DAYS,
    'overdue',
    'hasDueDate',
    'noDueDate',
  ],
}
